import {CircularProgress} from '@logistics-frontend/blocks/legacy'
import {Alert} from '@logistics-frontend/blocks/lpc/alert'
import {Button} from '@logistics-frontend/blocks/lpc/button'
import {Dialog, DialogContent, DialogTitleWithClose} from '@logistics-frontend/blocks/lpc/dialog'
import {useI18n} from '@logistics-frontend/core/i18n'
import {Snackbar} from '@material-ui/core'
import {SnackbarOrigin} from '@material-ui/core/Snackbar/Snackbar'
import {useTariff} from '@yandex-taxi/react-integration-api'
import {FrameMessageError} from '@yandex-trust-sdk/base/dist-cjs/types'
import React, {useCallback, useState} from 'react'

import {usePassportGoalCallback} from '../../metrika'
import {UNSTABLE__useZonePointUpdate, useEstimateTitle} from '../hooks'
import AddPaymentFrame from './AddPaymentFrame'

type Props = {
  loading: boolean
  disabled: boolean
}

const position: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}

const AddPaymentButton: React.FC<Props> = ({loading, disabled}) => {
  const t = useI18n()
  const [visible, setVisible] = useState<boolean>(false)
  const [error, setError] = useState<string>()
  const [{value: tariff}] = useTariff()
  const cardGoal = usePassportGoalCallback('LinkCard')
  const updateZonePoint = UNSTABLE__useZonePointUpdate()
  const hideHandler = useCallback(() => setVisible(false), [])
  const showHandler = useCallback(() => {
    setVisible(true)
    cardGoal()
  }, [cardGoal])
  const setErrorHandler = useCallback(
    (msg: FrameMessageError) => {
      hideHandler()
      setError(msg.reason)
    },
    [hideHandler],
  )
  const clearErrorHandler = useCallback(() => setError(undefined), [])
  const successHandler = useCallback(() => {
    hideHandler()
    updateZonePoint()
  }, [hideHandler, updateZonePoint])

  const startIcon = loading ? <CircularProgress color="secondary" size={20} /> : undefined
  const estimateTitle = useEstimateTitle(t('order.form.payment.bind_button_text', 'Привязать карту'), tariff, true)
  const text = loading ? t('order.form.payment.loading_text', 'Секундочку, думаем...') : estimateTitle

  return (
    <>
      <Button
        color="primary"
        disabled={disabled}
        onClick={showHandler}
        startIcon={startIcon}
        variant="contained"
        fullWidth
      >
        {text}
      </Button>
      {error && (
        <Snackbar anchorOrigin={position} autoHideDuration={10000} onClose={clearErrorHandler} open>
          <Alert severity="error" variant="filled">
            {error}
          </Alert>
        </Snackbar>
      )}
      {visible && (
        <Dialog maxWidth="md" fullWidth open>
          <DialogTitleWithClose onClose={hideHandler}>
            {t('order.form.payment.bind_dialog_title', 'Добавить платёжную карту')}
          </DialogTitleWithClose>
          <DialogContent>
            <AddPaymentFrame onAbort={hideHandler} onError={setErrorHandler} onSuccess={successHandler} />
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default AddPaymentButton
